import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { UserRoleDefaultFeatures } from '../models';

@Injectable({
  providedIn: 'root'
})
export class UserRoleDefaultFeaturesService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

   
     /**
    * This method is used to get the search results of UserRoleDefaultFeatures
    * based on the parameters.
    *
    * @param  pageNo  current page number
    * @param  pageSize Number of records per page
    * @param  sortField field needed to sort
    * @param  sortOrder whether the sorting field is ascending or descending
    * @param  appliedFilters appliedFilters
    * @return      json result
    */
    //   public searchUserRoleDefaultFeatures(pageNo:number,pageSize:number,sortField:string,sortOrder:string,appliedFilters:{field:string,matchMode:string,value:string}[]=[]):Observable<any> {
    //     return this.apiService.get(`UserRoleDefaultFeatures/SearchUserRoleDefaultFeatures?pageNo=${pageNo}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&appliedFilters=${appliedFilters}`)
    //   }

    public searchUserRoleDefaultFeatures(pageNo:number,pageSize:number,sortField:string,sortOrder:string,appliedFilters:{field:string,matchMode:string,value:string}[]=[]):Observable<any> {
        return this.apiService.get(`UserRoleDefaultFeatures/SearchUserRoleDefaultFeatures?pageNo=${pageNo}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&appliedFilters=${appliedFilters}`)
      }
  
  
      /**
      * This method is used to get all UserRoleDefaultFeatures records, there is no parameter
      *
      * @return      json result
      */
       public getAllUserRoleDefaultFeatures(userRoleDefaultFeaturesSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(userRoleDefaultFeaturesSearchParam);
        return this.apiService.post(`UserRoleDefaultFeatures/SearchUserRoleDefaultFeatures`,userRoleDefaultFeaturesSearchParam)
      }
  
      /**
      * This method is used to get individual UserRoleDefaultFeatures record based on the userRoleDefaultFeaturesid
      *
      * @param  userRoleFeaturesId  
      * @return      json result
      */
       public getUserRoleDefaultFeaturesById(userRoleFeaturesId:number):Observable<any> {
          return this.apiService.get(`UserRoleDefaultFeatures/${userRoleFeaturesId}`)
      }
  
      /**
      * This method is used to post/add new UserRoleDefaultFeatures record
      *
      * @param  UserRoleDefaultFeatures object which contains the userRoleDefaultFeatures record values
      * @return      json result
      */
       public postUserRoleDefaultFeatures(userRoleDefaultFeatures:UserRoleDefaultFeatures):Observable<any> {
          return this.apiService.post(`UserRoleDefaultFeatures`, userRoleDefaultFeatures)
      }
  
  
      /**
      * This method is used to update the existing UserRoleDefaultFeatures record
      *
      * @param  User userRoleDefaultFeatures Id 
      * @param  UserRoleDefaultFeatures object which contains the userRoleDefaultFeatures record values
      * @return      json result
      */
       public updateUserRoleDefaultFeatures(userRoleFeaturesId:number, userRoleDefaultFeatures:UserRoleDefaultFeatures):Observable<any> {
          return this.apiService.put(`UserRoleDefaultFeatures/${userRoleFeaturesId}`, userRoleDefaultFeatures)
      }
  
  
      /**
      * This method is used to delete the existing UserRoleDefaultFeatures record
      *
      * @param  User userRoleDefaultFeatures Id
      * @return      json result
      */
       public deleteUserRoleDefaultFeatures(userRoleFeaturesId:number):Observable<any> {
          return this.apiService.delete(`UserRoleDefaultFeatures/${userRoleFeaturesId}`)
      }

      getCompanyName():Observable<any>{
        return this.apiService.get(`CompanyProfile/AllApprovedCompanyList`)
      }

      getUserRole(companyId: number):Observable<any>{
        return this.apiService.get(`CompanyProfile/CompanyAllUserRolesList/${companyId}`)
      }
      
      getUserList(companyId: number, userRoleId: any, userName: string):Observable<any>{
        return this.apiService.get(`CompanyProfile/CompanyUsersByCriteria/${companyId}/${userRoleId}/${userName}`)
      }

      getUserRoleDefaultFeaturesByRoleId(profileId: number):Observable<any>{
        return this.apiService.get(`UserRoleDefaultFeatures/UserRoleDefaultFeaturesByUserProfileIdGroupFeature/${profileId}`)
      }

      public getFeaturesNotAddedForRoleId(roleId:number):Observable<any> {
        return this.apiService.get(`UserRoleDefaultFeatures/FeaturesNotAddedForRoleId/${roleId}`)
      }

      public ExportDefaultFeatures(defaultFeauturesSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}UserRoleDefaultFeatures/ExportUserDefaultFeatures`, defaultFeauturesSearchParam,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
  
}
